import React, { useEffect, useState } from 'react';
import styles from './sheduledInterviews.module.scss';
import {
    Route,
    Routes,
    Navigate,
    NavLink
} from 'react-router-dom';
import TabelView from './tableViewInterviews';
import CalendarView from './calendarViewInterviews';
import CustomNavbar from '../../customNavbar';
import { useLocation, useNavigate } from "react-router-dom";


const SheduledInterviews = (props) => {
    const history = useNavigate();

    const breadcrumb = [
        {
            pathaddress: '/app/company/scheduled-interviews',
            pathname: 'Scheduled Interviews',
            isActive: false,
            key: 1 + 'scheduled-interviews'
        }
    ];

    const breacrumbText = 'Scheduled interviews from all Vacancy Pipelines are listed here. Use the dropdown to filter by pipeline. You can reschedule/ cancel interviews here.'
    
    const [isToggled, setIsToggled] = useState(true);

    const onToggle = () => {
        setIsToggled(!isToggled);
    };

    useEffect(() => {
        if (isToggled) {
            history('/company/scheduled-interviews/table-view')
        }
        else {
            history('/company/scheduled-interviews/calendar-view')
        }

    }, [isToggled])

    return (
        <div className={styles.settingsBodyContainer}>
            <div className={styles.backgroundFixedComponents}>
                <CustomNavbar history={props.mainHistory} breadcrumbArray={breadcrumb}  breacrumbText= {breacrumbText}/>
            </div>
            <div className={styles.companySettingsBodyWrapper}>
                <div>
                    <div className={styles.toggleDiv}>
                        <label className={styles.toggleSwitch}>
                            <input type="checkbox" checked={isToggled} onChange={onToggle} />
                            <span className={styles.switch}>
                                <span className={styles.cardIconSpan}>
                                    <svg className={ isToggled?   styles.cardIconWhite  :styles.cardIconColord} width="18" height="18" viewBox="0 0 20 20" xmlns="http:www.w3.org/2000/svg">
                                        <path d="M1 7H19M5.8 1H14.2C15.8802 1 16.7202 1 17.362 1.32698C17.9265 1.6146 18.3854 2.07354 18.673 2.63803C19 3.27976 19 4.11984 19 5.8V14.2C19 15.8802 19 16.7202 18.673 17.362C18.3854 17.9265 17.9265 18.3854 17.362 18.673C16.7202 19 15.8802 19 14.2 19H5.8C4.11984 19 3.27976 19 2.63803 18.673C2.07354 18.3854 1.6146 17.9265 1.32698 17.362C1 16.7202 1 15.8802 1 14.2V5.8C1 4.11984 1 3.27976 1.32698 2.63803C1.6146 2.07354 2.07354 1.6146 2.63803 1.32698C3.27976 1 4.11984 1 5.8 1Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </span>
                                <span className={styles.calendarIconSpan}>
                                    <svg className={ isToggled?   styles.calendarIconColord : styles.calendarIconWhite } width="18" height="18" viewBox="0 0 20 22" xmlns="http:www.w3.org/2000/svg">
                                        <path d="M19 9H1M14 1V5M6 1V5M8.5 13L10 12V17M8.75 17H11.25M5.8 21H14.2C15.8802 21 16.7202 21 17.362 20.673C17.9265 20.3854 18.3854 19.9265 18.673 19.362C19 18.7202 19 17.8802 19 16.2V7.8C19 6.11984 19 5.27976 18.673 4.63803C18.3854 4.07354 17.9265 3.6146 17.362 3.32698C16.7202 3 15.8802 3 14.2 3H5.8C4.11984 3 3.27976 3 2.63803 3.32698C2.07354 3.6146 1.6146 4.07354 1.32698 4.63803C1 5.27976 1 6.11984 1 7.8V16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21Z" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </span>

                            </span>
                        </label>
                    </div>
                </div>
                <Routes>
                    <Route path='table-view' element={<TabelView {...props} />} />
                    <Route path='calendar-view' element={<CalendarView {...props} />} />
                    <Route index element={<Navigate replace to="table-view" />} />
                </Routes>
            </div>
        </div >
    )
}

export default SheduledInterviews;
